import { useEffect } from 'react';
import p5 from 'p5';

function P5Sketch({savior,setSavior}) {
  let variation = 0.02;
  let zoff = 0.00;
  let w = 1300;
  let h = 600;
  let angle = 0;
  let power = 0;
  let prop = 0;
  let minusprop = 0;
  let fieldpower = 250;
  let fade = 0;
  let fadespeed = 1;
  


  let particles = [];

  // Define the p5 sketch function
  const sketch = (p) => {
    p.setup = function () {
      if(!savior){

      w = p.windowWidth;
      h = p.windowHeight;
      var myCanvas = p.createCanvas(w, h);
      myCanvas.parent('dynamic-bg');
      myCanvas.position(0, 0);
      w = p.windowWidth;
      for (let i = 0; i < 100; i++) {
        particles[i] = new Particle(p);
        
      }
      setSavior(true);
    
    }
    }

    p.windowResized = function () {
      w = p.windowWidth;
      h = p.windowHeight;
      p.resizeCanvas(w, h);
    }

    p.draw = function () {

    if(document.getElementById('dynamic-bg') != null){
      if(document.getElementById('dynamic-bg').clientWidth === w) {
        if(fade < 160){ fade += fadespeed;}
      p.background('#331440');

      zoff = zoff + 0.04;
      for (let i = 0; i < particles.length; i++) {
        let noiseVal = p.noise(variation * particles[i].pos.x, variation* particles[i].pos.y, zoff);
  
        if (p.dist(particles[i].pos.x, particles[i].pos.y, p.mouseX, p.mouseY) < fieldpower) {
          if ((particles[i].pos.x - p.mouseX) > 0) {
            power = p.atan((particles[i].pos.y - p.mouseY) / (particles[i].pos.x - p.mouseX));
          } else {
            power = p.atan((particles[i].pos.y - p.mouseY) / (particles[i].pos.x - p.mouseX)) + p.PI;
          }
          prop = p.dist(particles[i].pos.x, particles[i].pos.y, p.mouseX, p.mouseY) / fieldpower;
          minusprop = 1 - prop;
        } else {
          prop = 1;
          minusprop = 0;
        }
  
        angle = noiseVal * p.TWO_PI * prop + power * minusprop;
        particles[i].applyForce(p.createVector(p.cos(angle), p.sin(angle)));
  
        particles[i].update();
        particles[i].show();
        particles[i].edges();
      }
    }
    } 
    else{
      setSavior(false);
      p.remove();
    
    }
      
    }
  };

  useEffect(() => {
    new p5(sketch);
  });

  // Particle constructor
  function Particle(p) {
    this.pos = p.createVector(p.random(p.windowWidth), p.random(p.windowHeight));
    this.vel = p.createVector(0, 0);
    this.acc = p.createVector(0, 0);
    this.seed = p.random(10, 40);

    this.update = function () {
      this.vel.add(this.acc);
      this.vel.setMag(1);
      this.pos.add(this.vel);
      this.acc.mult(0);
    }

    this.applyForce = function (force) {
      this.acc.add(force);
    }

    this.show = function () {
      p.fill(200 + this.seed * 2, 150, 200 + this.seed * 2, fade);
      p.noStroke();
      p.ellipse(this.pos.x, this.pos.y, this.seed, this.seed);
    }

    this.edges = function () {
      if (this.pos.x > p.windowWidth + 30) this.pos.x = -30;
      if (this.pos.x < -30) this.pos.x = p.windowWidth + 30;
      if (this.pos.y > p.windowHeight + 30) this.pos.y = -30;
      if (this.pos.y < -30) this.pos.y = p.windowHeight + 30;
    }
   
  }

  return null; // Or return some JSX if needed
}

export default P5Sketch;